// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2FL63","fileBtn":"File_fileBtn__1D57Z","closeBtn":"File_closeBtn__1c79s","fileSelected":"File_fileSelected__2P4qI","disabled":"File_disabled__1Nprc"};